import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VMenu,
    {
      attrs: { "offset-y": "", left: "", transition: "slide-y-transition" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                VBtn,
                _vm._g(
                  {
                    attrs: {
                      small: "",
                      text: "",
                      icon: _vm.$vuetify.breakpoint.smAndDown,
                    },
                  },
                  on
                ),
                [
                  _c("flag-icon", {
                    attrs: {
                      round: _vm.$vuetify.breakpoint.smAndDown,
                      flag: _vm.currentLocale.flag,
                    },
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$vuetify.breakpoint.mdAndUp &&
                            _vm.showLabel &&
                            !_vm.isMini,
                          expression:
                            "$vuetify.breakpoint.mdAndUp && showLabel && !isMini",
                        },
                      ],
                      class: [_vm.$vuetify.rtl ? "mr-1" : "ml-1"],
                    },
                    [_vm._v(_vm._s(_vm.currentLocale.label))]
                  ),
                  _vm.showArrow
                    ? _c(VIcon, { attrs: { right: "" } }, [
                        _vm._v("mdi-chevron-down"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        VList,
        { attrs: { dense: "", nav: "" } },
        _vm._l(_vm.availableLocales, function (locale) {
          return _c(
            VListItem,
            {
              key: locale.code,
              on: {
                click: function ($event) {
                  return _vm.setLocale(locale.code)
                },
              },
            },
            [
              _c("flag-icon", {
                class: [_vm.$vuetify.rtl ? "ml-1" : "mr-1"],
                attrs: { flag: locale.flag },
              }),
              _c(VListItemTitle, [_vm._v(_vm._s(locale.label))]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }